import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import InfoCircle from '@/images/circles/InfoCirclePrimary.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { StyledSlider } from '../../common/StyledSlider';

const StabilityControlContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 20px;
    gap: 8px;
    border: ${theme.colors.black[200]} 1px solid;
    border-radius: 8px;
`;

const StyledMaskedIcon = styled(MaskedIcon)`
    margin-bottom: -2px;
`;

const Text = styled.div`
    white-space: nowrap;
    font-size: 1.4rem;
`;

const StyledSliderWidth = styled(StyledSlider)`
    margin-left: auto;
    width: 210px;
`;

interface Props {
    value: number | string | undefined;
    setValue: (value: number) => void;
    isV3Model: boolean;
}

export const StabilityControl = ({ value, setValue, isV3Model }: Props) => {
    const stability = +(value ?? 0.3);

    return (
        <StabilityControlContainer>
            <Text>Stability ({(stability * 100).toFixed()}%)</Text>
            <CustomTooltip placement="top" title="Set higher to closely match the original voice. Avoid for poor-quality audio.">
                <StyledMaskedIcon src={InfoCircle} size="16px" color={theme.colors.secondary.main} />
            </CustomTooltip>
            <StyledSliderWidth
                aria-label="Stability"
                value={stability}
                onChange={(_e, value) => setValue(value as number)}
                step={isV3Model ? 0.5 : 0.05}
                min={0}
                max={1}
            />
        </StabilityControlContainer>
    );
};
